<mat-icon
  class="tooltip-icon locked-field-tooltip-icon"
  [matMenuTriggerFor]="lockedFieldTooltipMenu"
  #lockedFieldTrigger="matMenuTrigger"
  (mouseenter)="lockedFieldTrigger.openMenu()"
>
  info
</mat-icon>

<mat-menu
  #lockedFieldTooltipMenu="matMenu"
  [overlapTrigger]="false"
  class="tooltip-popover"
>
  <span
    (mouseleave)="lockedFieldTrigger.closeMenu()"
    [innerHTML]="message"
  >
  </span>
</mat-menu>
